import { z } from 'zod'

export function errorHandler(variable, setError) {
  const cliente = variable.tipo_cliente

  //verifica se tem mais de 6 numero no cliente (mesmo sendo string)
  const hasNumberInClient = cliente.replace(/\D/g, '').length > 6

  if (cliente.length > 6 && hasNumberInClient) {
    //retire todos os caracteres especiais
    variable.tipo_cliente = variable.tipo_cliente.replace(/[^a-zA-Z0-9]/g, '')

    if (
      variable.tipo_cliente.length > 6 &&
      variable.tipo_cliente.length < 11 &&
      hasNumberInClient
    ) {
      return setError('tipo_cliente', {
        type: 'manual',
        message: `Digite um CPF Válido, está faltando ${
          11 - variable.tipo_cliente.length
        } número(s)`,
      })
    } else if (
      variable.tipo_cliente.length > 11 &&
      variable.tipo_cliente.length < 14 &&
      hasNumberInClient
    ) {
      return setError('tipo_cliente', {
        type: 'manual',
        message: `Digite um CNPJ Válido, está faltando ${
          14 - variable.tipo_cliente.length
        } número(s)`,
      })
    }
  }

  if (
    variable.tipo_cliente.includes('.') &&
    variable.tipo_cliente.includes('-') &&
    !variable.tipo_cliente.includes('@')
  ) {
    variable.tipo_cliente = variable.tipo_cliente.replace(/[^a-zA-Z0-9]/g, '')
  }

  if (variable.tipo_cliente.includes('@')) {
    const emailSchema = z.object({
      email: z.string().email(),
    })

    try {
      emailSchema.parse({ email: variable.tipo_cliente })
    } catch (error) {
      return setError('tipo_cliente', {
        type: 'manual',
        message: 'Digite um email válido',
      })
    }
  }

  return true
}
